// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"2":"lang-fr-ts","64":"lang-zh-ts","305":"lang-de-ts","566":"lang-th-ts","597":"lang-no-ts","775":"lang-sv-ts","902":"lang-es-ts"}[chunkId] + "." + {"2":"796df39c","64":"a2efd538","305":"5ded3225","566":"a0a034b1","597":"e90dede4","775":"eacfe8a2","902":"ff46fe88"}[chunkId] + ".js";
};